import { z } from 'zod';

import { schemaAccountantManager } from './discriminatedUnions/accountantManager';
import { schemaAdmin } from './discriminatedUnions/admin';
import { schemaAdviser } from './discriminatedUnions/adviser';
import { schemaCorporationDirector } from './discriminatedUnions/corporationDirector';
import { schemaDivisionLeader } from './discriminatedUnions/divisionLeader';
import { schemaEmailManager } from './discriminatedUnions/emailManager';
import { schemaTeamLeader } from './discriminatedUnions/teamLeader';
import type { schemaUserCommon } from './discriminatedUnions/userCommon';

export const schemaUser = z.discriminatedUnion('role', [
    schemaAdmin,
    schemaEmailManager,
    schemaAdviser,
    schemaTeamLeader,
    schemaDivisionLeader,
    schemaCorporationDirector,
    schemaAccountantManager,
]);

export type Schema_User = z.infer<typeof schemaUser>;

export type Schema_UserCommon = z.infer<typeof schemaUserCommon>;

export type Schema_Admin = z.infer<typeof schemaAdmin>;
export type Schema_EmailManager = z.infer<typeof schemaEmailManager>;
export type Schema_Adviser = z.infer<typeof schemaAdviser>;
export type Schema_TeamLeader = z.infer<typeof schemaTeamLeader>;
export type Schema_DivisionLeader = z.infer<typeof schemaDivisionLeader>;
export type Schema_CorporationDirector = z.infer<typeof schemaCorporationDirector>;
export type Schema_AccountantManager = z.infer<typeof schemaAccountantManager>;

// Old schema
// export const User = z
//     .object({
//         absence: z
//             .array(
//                 z.object({
//                     absenceFrom: z.coerce.date(),
//                     absenceUntil: z.coerce.date(),
//                     delegateId: schemaId,
//                     eventId: schemaId,
//                     reason: z.optional(z.string().min(1)),
//                 }),
//             )
//             .optional()
//             .default([]),
//         assignable: z.boolean(),
//         avatar: z.string().optional(),
//         breakingEvent: schemaId.optional(),
//         buckets: z.array(z.nativeEnum(LOANREQUEST_BUCKETS)).optional(),
//         certData: z.string().nullish(),
//         certFileName: z.string().nullish(),
//         certKey: z.string().nullish(),
//         createdBy: z.string().trim().min(1),
//         deactivated: z.boolean().optional(),
//         delegateId: schemaId.nullish(),
//         email: z.string().email(),
//         europace: z
//             .object({
//                 partnerId: schemaEuropacePartnerId,
//             })
//             .nullish(),
//         firstName: z.string().trim().min(1),
//         gender: z.nativeEnum(USER_GENDER),
//         id: schemaId.optional(),
//         lastName: z.string().trim().min(1),
//         organization: z.string().optional(),
//         password: z.string().optional(),
//         // is required for every non admin user
//         phone: Phone.nullish(),
//         registered: z.boolean().optional(),
//         roles: z.array(z.nativeEnum(USER_ROLES)).min(1),
//         secret: z.string().optional(),
//         signatureId: schemaId.nullish(),
//         smtp: z
//             .object({
//                 password: z.string().min(1),
//                 user: z.string().min(1),
//             })
//             .nullable(),
//         state: z.number().optional(),
//         team: z.array(schemaId).nullish(),
//         teamLeader: z.string().nullish(),
//         title: z.string(),
//         tmpSecret: z.string().nullish(),
//     })
//     .superRefine((data, ctx) => {
//         if (!data.roles.includes(USER_ROLES.admin) && data.organization == null) {
//             ctx.addIssue({
//                 code: z.ZodIssueCode.custom,
//                 fatal: true,
//                 message: 'organization is a required field for non admin users',
//                 path: ['organization'],
//             });
//         }
//     });
